// Configuration éditable — adresses, contacts, lien de réservation
// Modifiez ces valeurs pour les répercuter partout sur le site.

export const SITE = {
  name: "Parfaits Imparfaits",
  practitioner: "Valentine DL",
  baseline: "Comprendre pour avancer, transformer pour se libérer",
  // Portrait de Valentine : déposer le fichier dans /frontend/public/img/ puis indiquer son chemin ici
  // (ex : "/img/valentine-portrait.webp"). Vide = aucune photo affichée (carte citation à la place).
  portrait: "",
  tagline: "Hypnose ericksonienne · Régressive & spirituelle",
  email: "v.parfaitsimparfaits@gmail.com",
  city: "Pantin",
  country: "France",
  // Localisation présentiel
  inPersonShort: "Pantin — Métro Église de Pantin (ligne 5), 15 min de Paris",
  inPersonFull: "Séances en présentiel à Pantin, à 15 min de Paris (Métro Église de Pantin, ligne 5).",
  // === À PERSONNALISER ===
  // Numéro WhatsApp (format international, sans + ni espaces, ex : 33685390783).
  // Laissez vide pour renvoyer vers la page /reserver (contact par e-mail / formulaire).
  whatsappNumber: "",
  whatsappMessage:
    "Bonjour Valentine, je souhaite réserver une séance d'hypnose. Pouvez-vous me communiquer vos disponibilités ? Merci !",
  // Lien SMS (utilise le numéro WhatsApp par défaut)
  smsMessage: "Bonjour Valentine, je souhaite réserver une séance d'hypnose.",
  // Option future : lien de réservation en ligne (Cal.com, Calendly…). Prioritaire si renseigné.
  bookingUrl: "",
  // Réseaux sociaux (optionnel)
  youtube: "https://www.youtube.com/@ParfaitsImparfaits",
  instagram: "https://www.instagram.com/parfaits_imparfaits/",
  // Mentions légales — à compléter
  legal: {
    siren: "",
    siret: "",
    address: "Paris, France",
    director: "Valentine DL",
    hostName: "Emergent Hosting",
    hostAddress: "Hébergement géré via la plateforme Emergent",
  },
};

export function bookingHref() {
  if (SITE.bookingUrl && SITE.bookingUrl.trim()) return SITE.bookingUrl;
  if (SITE.whatsappNumber && SITE.whatsappNumber.trim()) {
    const msg = encodeURIComponent(SITE.whatsappMessage || "");
    return `https://wa.me/${SITE.whatsappNumber}?text=${msg}`;
  }
  return "/reserver";
}

export function isExternalBooking() {
  return !!(
    (SITE.bookingUrl && SITE.bookingUrl.trim()) ||
    (SITE.whatsappNumber && SITE.whatsappNumber.trim())
  );
}

export function smsHref() {
  if (!SITE.whatsappNumber) return null;
  const body = encodeURIComponent(SITE.smsMessage || "");
  return `sms:+${SITE.whatsappNumber}?&body=${body}`;
}
